/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PromptVisualisation } from './PromptVisualisation';
import {
    PromptVisualisationFromJSON,
    PromptVisualisationFromJSONTyped,
    PromptVisualisationToJSON,
} from './PromptVisualisation';

/**
 * 
 * @export
 * @interface ListPromptVisualisationsResponseContent
 */
export interface ListPromptVisualisationsResponseContent {
    /**
     * 
     * @type {Array<PromptVisualisation>}
     * @memberof ListPromptVisualisationsResponseContent
     */
    visualisations?: Array<PromptVisualisation>;
}


/**
 * Check if a given object implements the ListPromptVisualisationsResponseContent interface.
 */
export function instanceOfListPromptVisualisationsResponseContent(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ListPromptVisualisationsResponseContentFromJSON(json: any): ListPromptVisualisationsResponseContent {
    return ListPromptVisualisationsResponseContentFromJSONTyped(json, false);
}

export function ListPromptVisualisationsResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListPromptVisualisationsResponseContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'visualisations': !exists(json, 'visualisations') ? undefined : ((json['visualisations'] as Array<any>).map(PromptVisualisationFromJSON)),
    };
}

export function ListPromptVisualisationsResponseContentToJSON(value?: ListPromptVisualisationsResponseContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'visualisations': value.visualisations === undefined ? undefined : ((value.visualisations as Array<any>).map(PromptVisualisationToJSON)),
    };
}

